import { PayloadAction } from '../../../../store.model';
import { groups } from '../const/view-groups.const';
import { groupItems } from '../function/group-items.function';
import { sortItems } from '../function/sort-items.function';
import { ViewTaskItem } from '../model/view-task-item.model';
import { ActionType } from '../task-list-dialog.action';
import { TaskListDialogState } from '../task-list-dialog.state';

import { SortItems } from './sort-items.action';

export function sortItemsReducer(
    state: TaskListDialogState,
    action: PayloadAction<ActionType, SortItems>,
): TaskListDialogState {
    try {
        const viewItems: ViewTaskItem[] = [];
        state.groups.forEach((e) => {
            viewItems.push(...e.tasks);
        });

        const sortedItems = sortItems(action.payload.orderBy, viewItems);

        const nextGroups = groupItems(groups, sortedItems);

        return {
            ...state,
            orderBy: action.payload.orderBy,
            groups: nextGroups,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
